// import-sort-ignore
import _ from 'lodash';

import { isProduction } from '@zapier/common-utils';
import { Account, Profile } from '@zapier/shared-entities';
import { emit } from '@zapier/events-toolkit-browser';

import Data from './Data';

const isProd = isProduction();

const debouncedTrackByMessage = {};

const logForAbTestValidation = (message, data) => {
  const isUsingOldLaneProp = data && data.lane;
  if (isUsingOldLaneProp) {
    console.warn(
      '!!! using the `lane` property is deprecated -- use `variant` or ideally maybeRenderIfAbTest()!'
    );
  }

  const isBirthButImproper =
    _.endsWith(message, 'birth') &&
    (!_.startsWith(message, 'test: ') || !_.endsWith(message, '_birth'));

  const isTestButNotBirth =
    _.startsWith(message, 'test: ') && !_.endsWith(message, '_birth');

  if (isBirthButImproper || isTestButNotBirth) {
    console.warn(
      '!!! birth events should follow `test: {name}_birth` -- consider using maybeRenderIfAbTest()!'
    );
  }

  const isMissingVariant =
    message &&
    _.startsWith(message, 'test: ') &&
    _.endsWith(message, '_birth') &&
    data &&
    !data.variant;
  if (isMissingVariant) {
    console.warn(
      '!!! birth events should include a `variant` property -- consider using maybeRenderIfAbTest()!'
    );
  }
};

const send = (message, data) => {
  if (!isProd) {
    console.info('tracking an event:', message, data);
    logForAbTestValidation(message, data);
  }
  Data.trackEvent(message, data);
};

const TrackActions = {
  track(message, data, wait = 200) {
    return (dispatch, getState) => {
      if (!debouncedTrackByMessage[message]) {
        debouncedTrackByMessage[message] = _.throttle(send, wait);
      }
      const state = getState();
      const account_id = Account.selectors.all.currentAccountId(state);
      const userId = Profile.selectors.all.currentProfileId(state);
      return debouncedTrackByMessage[message](message, {
        ...data,
        account_id,
        userId,
      });
    };
  },

  async trackPageViewEvent() {
    const referrer = document.referrer;
    await emit(
      { system_name: 'monolith', referrer },
      'web_analytics.tracking.page_view.PageViewEvent'
    );
  },

  gaPageTrack(path) {
    return (dispatch, getState) => {
      if (!path) {
        const { router } = getState();
        path = _.get(router, ['current', 'location'], window.location || {})
          .pathname;
      }
      Data.gaPageTrack(
        path,
        Profile.selectors.all.currentProfileId(getState())
      );
    };
  },
};

export default TrackActions;
